import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="voting"
export default class extends Controller {
  static targets = ["button", "icon", "count"]
  static values = { 
    url: String,
    voteType: String,
    currentlyVoted: Boolean,
    currentScore: Number
  }

  async vote(event) {
    event.preventDefault()
    
    // Prevent double-clicking
    if (this.isSubmitting) return
    this.isSubmitting = true

    // Optimistic UI update
    this.updateUIOptimistically()

    try {
      const response = await fetch(this.urlValue + '.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: `vote_type=${this.voteTypeValue}`
      })

      if (response.ok) {
        const result = await response.json()
        
        // Update with server response
        this.updateUI(result.voted, result.score)
        
        // Brief success animation
        if (result.voted) {
          this.showSuccessAnimation()
        }
        
      } else {
        // Revert optimistic update on error
        this.revertOptimisticUpdate()
        console.error('Voting failed:', response.status)
      }
      
    } catch (error) {
      // Revert optimistic update on error
      this.revertOptimisticUpdate()
      console.error('Voting error:', error)
    } finally {
      this.isSubmitting = false
    }
  }

  updateUIOptimistically() {
    // Store current state for potential revert
    this.previousState = {
      voted: this.currentlyVotedValue,
      score: this.currentScoreValue
    }

    // Calculate new state - toggling the upvote
    const newVoted = !this.currentlyVotedValue
    let newScore = this.currentScoreValue

    if (this.currentlyVotedValue) {
      // Currently voted (upvoted), so removing the upvote
      newScore -= 1
    } else {
      // Not currently voted, so adding an upvote
      newScore += 1
    }

    this.updateUI(newVoted, newScore)
  }

  revertOptimisticUpdate() {
    if (this.previousState) {
      this.updateUI(this.previousState.voted, this.previousState.score)
    }
  }

  updateUI(voted, score) {
    // Update values
    this.currentlyVotedValue = voted
    this.currentScoreValue = score

    // Update heart icon
    if (voted) {
      this.iconTarget.classList.remove('far')
      this.iconTarget.classList.add('fas')
      this.buttonTarget.classList.remove('text-gray-500', 'hover:text-red-500')
      this.buttonTarget.classList.add('text-red-500')
    } else {
      this.iconTarget.classList.remove('fas')
      this.iconTarget.classList.add('far')
      this.buttonTarget.classList.remove('text-red-500')
      this.buttonTarget.classList.add('text-gray-500', 'hover:text-red-500')
    }

    // Update count with color
    this.countTarget.textContent = score
    if (score > 0) {
      this.countTarget.classList.remove('text-gray-500', 'text-gray-400')
      this.countTarget.classList.add('text-red-500')
    } else {
      this.countTarget.classList.remove('text-red-500')
      this.countTarget.classList.add(score < 0 ? 'text-gray-400' : 'text-gray-500')
    }
  }

  showSuccessAnimation() {
    // Brief scale animation on the heart
    this.iconTarget.style.transform = 'scale(1.2)'
    this.iconTarget.style.transition = 'transform 0.1s ease'
    
    setTimeout(() => {
      this.iconTarget.style.transform = 'scale(1)'
    }, 100)

    // Reset transition after animation
    setTimeout(() => {
      this.iconTarget.style.transition = ''
    }, 200)
  }
}